import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=0533293a&scoped=true&"
import script from "./Checkmark.vue?vue&type=script&lang=js&"
export * from "./Checkmark.vue?vue&type=script&lang=js&"
import style0 from "./Checkmark.vue?vue&type=style&index=0&id=0533293a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533293a",
  null
  
)

export default component.exports